import React, { lazy, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  CBadge,
  CButton,
  CButtonGroup,
  CCard,
  CCardBody,
  CCardFooter,
  CCardHeader,
  CCol,
  CProgress,
  CRow,
  CImg,
  CCallout,
  CCardText
} from 'compat/coreui'
import CIcon from 'compat/coreui-icon'
import axios from 'axios';
import MainChartExample from '../charts/MainChartExample.js'
import Visitors from '../charts/Visitors.js'

import WidgetsDropdown from '../widgets/WidgetsDropdown.js';
import WidgetsBrand from '../widgets/WidgetsBrand.js';

const Dashboard = () => {
  const history = useNavigate()
  const [analyticsData, setAnalyticsData] = useState([])
  const [response, setResponse] = useState({})
  const [totalUsers, setTotalUsers] = useState(0)
  const [totalReviews, setTotalReviews] = useState(0)
  const [totalFollowers, setTotalFollowers] = useState(0)
  const [totalVisitors, setTotalVisitors] = useState(0)
  const [totalPreOrdersPending, setTotalPreOrdersPending] = useState(0)
  const token = localStorage.getItem('token');

  useEffect(() => {
    getAnalyticsData();
  }, [])

  const getAnalyticsData = () => {
    axios({
      url: `${process.env.REACT_APP_APP_API_URL}/api/dashboard`,
      method: 'GET',
      headers: {
        'Authorization': 'Bearer ' + token
      }
    }).then(response => {
      if (response.data.status) {
        setAnalyticsData(response.data.visitors.sort((a,b) => {
          if (b._id > a._id) return -1
          if (b._id < a._id) return 1
          if (b._id === a._id) return 0
        }));
        setTotalVisitors(response.data.visitors.length);
        setTotalUsers(response.data.totalUsers);
        setTotalReviews(response.data.totaReviews);
        setTotalFollowers(response.data.followerCount);
        setTotalPreOrdersPending(response.data.preOrderCount);
        // setAnalyticsData(response.data);
      }
    }).catch(console.log)
  }

  return (
    <>
      <WidgetsDropdown />
      <CCard>
        <CCardBody>
          <CRow>
            <CCol sm="5">
              <h4 id="traffic" className="card-title mb-0">Recent Traffic</h4>
              <div className="small text-muted">November 2017</div>
            </CCol>
            <CCol sm="7" className="d-none d-md-block">
              <CButton color="primary" className="float-right">
                <CIcon name="cil-cloud-download" />
              </CButton>
              <CButtonGroup className="float-right mr-3">
                {
                  ['Day', 'Month', 'Year'].map(value => (
                    <CButton
                      color="outline-secondary"
                      key={value}
                      className="mx-0"
                      active={value === 'Month'}
                    >
                      {value}
                    </CButton>
                  ))
                }
              </CButtonGroup>
            </CCol>
          </CRow>
          {(analyticsData && analyticsData.length > 0) ? <Visitors style={{ height: '300px', marginTop: '40px' }} analyticsData={analyticsData} />: null}
        </CCardBody>
        <CCardFooter>
          <CRow className="text-center">
            <CCol md sm="12" className="mb-sm-2 mb-0">
              <div className="text-muted">30 DAY VISITORS</div>
              <strong>{totalVisitors} Users ({((totalVisitors * 100) / totalUsers).toFixed(2)}%)</strong>
              <CProgress
                className="progress-xs mt-2"
                precision={1}
                color="success"
                value={40}
              />
            </CCol>
            <CCol md sm="12" className="mb-sm-2 mb-0 d-md-down-none">
              <div className="text-muted">New Visitors</div>
              <strong>{totalVisitors} ({((totalVisitors * 100) / totalUsers).toFixed(2)}%)</strong>
              <CProgress
                className="progress-xs mt-2"
                precision={1}
                color="info"
                value={40}
              />
            </CCol>
            <CCol md sm="12" className="mb-sm-2 mb-0">
              <div className="text-muted">Pre Orders</div>
              <strong>{totalPreOrdersPending}</strong>
              <CProgress
                className="progress-xs mt-2"
                precision={1}
                color="warning"
                value={40}
              />
            </CCol>
            <CCol md sm="12" className="mb-sm-2 mb-0">
              <div className="text-muted">Followers</div>
              <strong>{totalFollowers} ({((totalFollowers * 100) / totalUsers).toFixed(2)}%)</strong>
              <CProgress
                className="progress-xs mt-2"
                precision={1}
                color="danger"
                value={40}
              />
            </CCol>
            <CCol md sm="12" className="mb-sm-2 mb-0 d-md-down-none">
              <div className="text-muted">Reviews</div>
              <strong>{totalReviews}</strong>
              <CProgress
                className="progress-xs mt-2"
                precision={1}
                value={40}
              />
            </CCol>
          </CRow>
        </CCardFooter>
      </CCard>

      <WidgetsBrand withCharts />
      <CRow className="text-center">
        <CCol sm={12} lg={4}>
          <CCard>
            <CCardHeader>
              Menu & Products
            </CCardHeader>
            <CCardBody className="text-center" style={{padding:"20px"}}>
              <CRow>
                <CIcon name="cil-list" size="2xl" />
                <CCardText>Pre order </CCardText>
              </CRow>
              <CRow>
                <CIcon name="cil-list" size="2xl" />
                <CCardText>Pre order </CCardText>
              </CRow>
              <CRow>
                <CIcon name="cil-list" size="2xl" />
                <CCardText>Pre order </CCardText>
              </CRow>
            </CCardBody>
          </CCard>
        </CCol>
        <CCol sm={12} lg={4}>
          <CCard>
            <CCardHeader>
              Specials & Deals
            </CCardHeader>
            <CCardBody className="text-center" style={{ padding: "0px" }}>
              <CCol >
                <CCardBody>
                  <CRow>
                    <CImg style={{ maxHeight: "30px" }} src="/images/p-tag.png" />
                    <p style={{marginTop:"0px"}}>Add your daily deals &amp; specials to attract the bargain hunters in your community!</p>
                  </CRow>
                  <span>1 CREDIT</span>
                </CCardBody>
              </CCol>
            </CCardBody>
          </CCard>
        </CCol>
        <CCol sm={12} lg={4}>
          <CCard>
            <CCardHeader>
              Billing
            </CCardHeader>
            <CCardBody className="text-center">
              <CCol >
                <CCardBody>
                  {/* <CImg src="/images/p-tag.png" /> */}
                  <p>Package:</p>
                  <span>Claimed Listing $0 /mo</span>
                  <CButton style={{ marginBottom: "10px" }} color="success" className="text-white p-3 mt-2">UPGRADE YOUR LISTING</CButton>
                </CCardBody>
              </CCol>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
      <CRow className="text-center">
        <CCol sm={12} lg={4}>
          <CCard>
            <CCardHeader>
              Online Pre-Ordering
            </CCardHeader>
            <CCardBody className="text-center" style={{padding:"20px"}}>
              <p>Pre-ordering not available with your current package selection</p>
              <CButton style={{ marginBottom: "10px" }} color="success" className="text-white p-3 mt-2" onClick={() => {history('/dashboard/upgrade')}}>UPGRADE YOUR LISTING</CButton>
            </CCardBody>
          </CCard>
        </CCol>
        </CRow> 
      {/*<CRow>
        <CCol>
          <CCard>
            <CCardHeader>
              Business Insights
            </CCardHeader>
            <CCardBody>
              <CRow>
                <CCol xs="12" md="6" xl="6">

                  <CRow>
                    <CCol sm="6">
                      <CCallout color="info">
                        <small className="text-muted">New Clients</small>
                        <br />
                        <strong className="h4">9,123</strong>
                      </CCallout>
                    </CCol>
                    <CCol sm="6">
                      <CCallout color="danger">
                        <small className="text-muted">Recurring Clients</small>
                        <br />
                        <strong className="h4">22,643</strong>
                      </CCallout>
                    </CCol>
                  </CRow>

                  <hr className="mt-0" />

                  <div className="progress-group mb-4">
                    <div className="progress-group-prepend">
                      <span className="progress-group-text">
                        Monday
                      </span>
                    </div>
                    <div className="progress-group-bars">
                      <CProgress className="progress-xs" color="info" value="34" />
                      <CProgress className="progress-xs" color="danger" value="78" />
                    </div>
                  </div>
                  <div className="progress-group mb-4">
                    <div className="progress-group-prepend">
                      <span className="progress-group-text">
                        Tuesday
                      </span>
                    </div>
                    <div className="progress-group-bars">
                      <CProgress className="progress-xs" color="info" value="56" />
                      <CProgress className="progress-xs" color="danger" value="94" />
                    </div>
                  </div>
                  <div className="progress-group mb-4">
                    <div className="progress-group-prepend">
                      <span className="progress-group-text">
                        Wednesday
                      </span>
                    </div>
                    <div className="progress-group-bars">
                      <CProgress className="progress-xs" color="info" value="12" />
                      <CProgress className="progress-xs" color="danger" value="67" />
                    </div>
                  </div>
                  <div className="progress-group mb-4">
                    <div className="progress-group-prepend">
                      <span className="progress-group-text">
                        Thursday
                      </span>
                    </div>
                    <div className="progress-group-bars">
                      <CProgress className="progress-xs" color="info" value="43" />
                      <CProgress className="progress-xs" color="danger" value="91" />
                    </div>
                  </div>
                  <div className="progress-group mb-4">
                    <div className="progress-group-prepend">
                      <span className="progress-group-text">
                        Friday
                      </span>
                    </div>
                    <div className="progress-group-bars">
                      <CProgress className="progress-xs" color="info" value="22" />
                      <CProgress className="progress-xs" color="danger" value="73" />
                    </div>
                  </div>
                  <div className="progress-group mb-4">
                    <div className="progress-group-prepend">
                      <span className="progress-group-text">
                        Saturday
                      </span>
                    </div>
                    <div className="progress-group-bars">
                      <CProgress className="progress-xs" color="info" value="53" />
                      <CProgress className="progress-xs" color="danger" value="82" />
                    </div>
                  </div>
                  <div className="progress-group mb-4">
                    <div className="progress-group-prepend">
                      <span className="progress-group-text">
                        Sunday
                      </span>
                    </div>
                    <div className="progress-group-bars">
                      <CProgress className="progress-xs" color="info" value="9" />
                      <CProgress className="progress-xs" color="danger" value="69" />
                    </div>
                  </div>
                  <div className="legend text-center">
                    <small>
                      <sup className="px-1"><CBadge shape="pill" color="info">&nbsp;</CBadge></sup>
                      New clients
                      &nbsp;
                      <sup className="px-1"><CBadge shape="pill" color="danger">&nbsp;</CBadge></sup>
                      Recurring clients
                    </small>
                  </div>
                </CCol>

                <CCol xs="12" md="6" xl="6">

                  <CRow>
                    <CCol sm="6">
                      <CCallout color="warning">
                        <small className="text-muted">Pageviews</small>
                        <br />
                        <strong className="h4">78,623</strong>
                      </CCallout>
                    </CCol>
                    <CCol sm="6">
                      <CCallout color="success">
                        <small className="text-muted">Organic</small>
                        <br />
                        <strong className="h4">49,123</strong>
                      </CCallout>
                    </CCol>
                  </CRow>

                  <hr className="mt-0" />

                  <div className="progress-group mb-4">
                    <div className="progress-group-header">
                      <CIcon className="progress-group-icon" name="cil-user" />
                      <span className="title">Male</span>
                      <span className="ml-auto font-weight-bold">43%</span>
                    </div>
                    <div className="progress-group-bars">
                      <CProgress className="progress-xs" color="warning" value="43" />
                    </div>
                  </div>
                  <div className="progress-group mb-5">
                    <div className="progress-group-header">
                      <CIcon className="progress-group-icon" name="cil-user-female" />
                      <span className="title">Female</span>
                      <span className="ml-auto font-weight-bold">37%</span>
                    </div>
                    <div className="progress-group-bars">
                      <CProgress className="progress-xs" color="warning" value="37" />
                    </div>
                  </div>
                  <div className="progress-group">
                    <div className="progress-group-header">
                      <CIcon className="progress-group-icon" name="cil-globe-alt" />
                      <span className="title">Organic Search</span>
                      <span className="ml-auto font-weight-bold">191,235 <span className="text-muted small">(56%)</span></span>
                    </div>
                    <div className="progress-group-bars">
                      <CProgress className="progress-xs" color="success" value="56" />
                    </div>
                  </div>


                  <div className="progress-group">
                    <div className="progress-group-header">
                      <CIcon name="cib-facebook" className="progress-group-icon" />
                      <span className="title">Facebook</span>
                      <span className="ml-auto font-weight-bold">51,223 <span className="text-muted small">(15%)</span></span>
                    </div>
                    <div className="progress-group-bars">
                      <CProgress className="progress-xs" color="success" value="15" />
                    </div>
                  </div>
                  <div className="progress-group">
                    <div className="progress-group-header">
                      <CIcon name="cib-twitter" className="progress-group-icon" />
                      <span className="title">Twitter</span>
                      <span className="ml-auto font-weight-bold">37,564 <span className="text-muted small">(11%)</span></span>
                    </div>
                    <div className="progress-group-bars">
                      <CProgress className="progress-xs" color="success" value="11" />
                    </div>
                  </div>
                  <div className="progress-group">
                    <div className="progress-group-header">
                      <CIcon name="cib-linkedin" className="progress-group-icon" />
                      <span className="title">LinkedIn</span>
                      <span className="ml-auto font-weight-bold">27,319 <span className="text-muted small">(8%)</span></span>
                    </div>
                    <div className="progress-group-bars">
                      <CProgress className="progress-xs" color="success" value="8" />
                    </div>
                  </div>
                  <div className="divider text-center">
                    <CButton color="link" size="sm" className="text-muted">
                      <CIcon name="cil-options" />
                    </CButton>
                  </div>

                </CCol>
              </CRow>

              <br />

            </CCardBody>
          </CCard>
        </CCol>
      </CRow>*/}
    </>
  )
}

export default Dashboard
